import React from 'react';
import { ProjectCard } from '../components';

const CardWrapper = () => {
  return (
    <>
      <h1>📌 ProjectCard</h1>

      <div className="demo-wrapper">
        <section>
          <h3>프로젝트 카드</h3>
          <ProjectCard
            title="기본적인 프로젝트 카드"
            tags={['서머스쿨', '기초']}
          />
          <ProjectCard title="태그가 없는 프로젝트 카드" />
          <ProjectCard
            title="프로젝트의 타이틀이 아주아주 많이 길 때는 이렇게 표시됩니다. 굉장히 긴 프로젝트의 이름입니다."
            author="코딩엑스AI가 기본값이지만 혹시 저작자의 이름이 아주아주 길 때는 이렇게 표시됩니다."
            tags={[
              '태그가',
              '많이',
              '있을때는',
              '다음과',
              '같이',
              '표시',
              '됩니다',
            ]}
          />
        </section>
        <p>1. hover했을 때의 상태, 2. 태그가 많을 때 어떻게 표시될 지</p>

        <section>
          <h3>프로젝트 카드 - 레벨별 디폴트 이미지</h3>
          <ProjectCard
            title="디폴트 이미지 - 레벨 0"
            tags={['서머스쿨', '기초']}
          />
          <ProjectCard
            title="디폴트 이미지 - 레벨 1"
            level={1}
            tags={['서머스쿨', '기초']}
          />
          <ProjectCard
            title="디폴트 이미지 - 레벨 2"
            level={2}
            tags={['서머스쿨', '기초']}
          />
          <ProjectCard
            title="디폴트 이미지 - 레벨 3"
            level={3}
            tags={['서머스쿨', '기초']}
          />
        </section>

        <section>
          <h3>프로젝트 카드 - 완료 상태 </h3>
          <ProjectCard
            title="완료되지 않은 프로젝트"
            tags={['서머스쿨', '기초']}
          />
          <ProjectCard
            title="완료된 프로젝트"
            tags={['서머스쿨', '기초']}
            isCompleted
          />
          <ProjectCard
            title="완료된 프로젝트가 긴 저작자 이름을 가졌을 때"
            author="코딩엑스AI가 기본값이지만 혹시 저작자의 이름이 아주아주 길 때는 이렇게 표시됩니다."
            tags={['서머스쿨', '기초']}
            level={3}
            isCompleted
          />
          <ProjectCard
            title="완료된 프로젝트가 긴 저작자 이름을 가졌는데 태그도 많아요"
            author="코딩엑스AI가 기본값이지만 혹시 저작자의 이름이 아주아주 길 때는 이렇게 표시됩니다."
            level={3}
            tags={[
              '태그도',
              '많이',
              '있을때',
              '완료된',
              '프로젝트',
              '샘플',
              '입니다',
            ]}
            isCompleted
          />
        </section>

        <section style={{ background: '#fff', padding: '24px 0' }}>
          <h3>프로젝트 카드 - 기타 상태</h3>

          <ProjectCard
            title="구글로 링크 - 현재 페이지"
            href="https://www.google.com"
            tags={['서머스쿨', '기초']}
          />
          <ProjectCard
            title="구글로 링크 - 새 페이지"
            href="https://www.google.com"
            target="_blank"
            tags={['서머스쿨', '기초']}
          />
          <ProjectCard
            title="랜덤 이미지를 설정했을 때"
            imageSrc="https://picsum.photos/300/300"
            tags={['서머스쿨', '기초']}
          />
        </section>
      </div>
    </>
  );
};

export default CardWrapper;
